// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2E85G","buttons":"Footer_buttons__94Vp9"};